import styled from 'styled-components';
import { MONOLITH } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const H1Component = styled.h1.withConfig({
  displayName: "PublicH1__H1Component",
  componentId: "vc2zxc-0"
})(["color:", ";font-weight:500;"], MONOLITH);

/**
 * A semantic `h1` element with bespoke styling across the public docs site.
 * Unlike the `UIComponents` heading, does not add an unnecessary `aria-level`.
 * Still uses and extends `UIComponents` base heading styles.
 *
 * Import this component, then add layout-specific styles.
 * @example
 * ```tsx
 *  import PublicH1 from 'developer-docs-shared-components/components/PublicH1';
 *
 *  const H1 = styled(PublicH1)`
 *    margin: 5vw 0;
 *  `;
 * ```
 *
 * @see https://uxplanet.org/should-i-use-aria-level-in-the-h-tag-8efc2cd0a114
 * @see https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-level#with_heading_role
 */
const PublicH1 = props => /*#__PURE__*/_jsx(H1Component, Object.assign({}, props));
export default PublicH1;